import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { Shell } from '@/components/layout/Shell';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { ForbiddenPage } from '@/pages/ForbiddenPage';
import { ModulePlaceholder } from '@/pages/ModulePlaceholder';
import { ClientsListPage } from '@/pages/clients/ClientsListPage';
import { ClientDetailPage } from '@/pages/clients/ClientDetailPage';
import { QuotesListPage } from '@/pages/quotes/QuotesListPage';
import { QuoteDetailPage } from '@/pages/quotes/QuoteDetailPage';
import { OrdersListPage } from '@/pages/orders/OrdersListPage';
import { OrderDetailPage } from '@/pages/orders/OrderDetailPage';
import { InventoryListPage } from '@/pages/inventory/InventoryListPage';
import { InventoryDetailPage } from '@/pages/inventory/InventoryDetailPage';
import { FinancialsLayout } from '@/pages/financials/FinancialsLayout';
import { InvoicesPage } from '@/pages/financials/InvoicesPage';
import { InvoiceDetailPage } from '@/pages/financials/InvoiceDetailPage';
import { PaymentsPage } from '@/pages/financials/PaymentsPage';
import { AgingPage } from '@/pages/financials/AgingPage';
import { AccountingLayout } from '@/pages/accounting/AccountingLayout';
import { ChartOfAccountsPage } from '@/pages/accounting/ChartOfAccountsPage';
import { JournalPage } from '@/pages/accounting/JournalPage';
import { TrialBalancePage } from '@/pages/accounting/TrialBalancePage';
import { ProfitLossPage } from '@/pages/accounting/ProfitLossPage';
import { BalanceSheetPage } from '@/pages/accounting/BalanceSheetPage';
import { ProductionLayout } from '@/pages/production/ProductionLayout';
import { ShopFloorBoardPage } from '@/pages/production/ShopFloorBoardPage';
import { TicketsListPage } from '@/pages/production/TicketsListPage';
import { TicketDetailPage } from '@/pages/production/TicketDetailPage';
import { SchedulePage } from '@/pages/production/SchedulePage';
import { NewsletterLayout } from '@/pages/newsletter/NewsletterLayout';
import { CampaignsPage } from '@/pages/newsletter/CampaignsPage';
import { CampaignEditorPage } from '@/pages/newsletter/CampaignEditorPage';
import { CampaignDetailPage } from '@/pages/newsletter/CampaignDetailPage';
import { SubscribersPage } from '@/pages/newsletter/SubscribersPage';
import { AudiencesPage } from '@/pages/newsletter/AudiencesPage';
import { TemplatesPage } from '@/pages/newsletter/TemplatesPage';
import { SuppressionsPage } from '@/pages/newsletter/SuppressionsPage';
import { SettingsLayout } from '@/pages/settings/SettingsLayout';
import { UsersSettings } from '@/pages/settings/UsersSettings';
import { RolesSettings } from '@/pages/settings/RolesSettings';
import { CompanySettings } from '@/pages/settings/CompanySettings';
import { IntegrationsSettings } from '@/pages/settings/IntegrationsSettings';
import { AuditSettings } from '@/pages/settings/AuditSettings';
import { PreferencesSettings } from '@/pages/settings/PreferencesSettings';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        element={
          <ProtectedRoute>
            <Shell />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />

        <Route path="/clients" element={
          <ProtectedRoute module="clients">
            <ClientsListPage />
          </ProtectedRoute>
        } />
        <Route path="/clients/:id" element={
          <ProtectedRoute module="clients">
            <ClientDetailPage />
          </ProtectedRoute>
        } />

        <Route path="/quotes" element={
          <ProtectedRoute module="quotes">
            <QuotesListPage />
          </ProtectedRoute>
        } />
        <Route path="/quotes/:id" element={
          <ProtectedRoute module="quotes">
            <QuoteDetailPage />
          </ProtectedRoute>
        } />

        <Route path="/orders" element={
          <ProtectedRoute module="orders">
            <OrdersListPage />
          </ProtectedRoute>
        } />
        <Route path="/orders/:id" element={
          <ProtectedRoute module="orders">
            <OrderDetailPage />
          </ProtectedRoute>
        } />

        <Route path="/production" element={
          <ProtectedRoute module="production">
            <ProductionLayout />
          </ProtectedRoute>
        }>
          <Route index                  element={<Navigate to="/production/board" replace />} />
          <Route path="board"           element={<ShopFloorBoardPage />} />
          <Route path="tickets"         element={<TicketsListPage />} />
          <Route path="tickets/:id"     element={<TicketDetailPage />} />
          <Route path="schedule"        element={<SchedulePage />} />
        </Route>

        <Route path="/inventory" element={
          <ProtectedRoute module="inventory">
            <InventoryListPage />
          </ProtectedRoute>
        } />
        <Route path="/inventory/:id" element={
          <ProtectedRoute module="inventory">
            <InventoryDetailPage />
          </ProtectedRoute>
        } />

        <Route path="/financials" element={
          <ProtectedRoute module="financials">
            <FinancialsLayout />
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="/financials/invoices" replace />} />
          <Route path="invoices"     element={<InvoicesPage />} />
          <Route path="invoices/:id" element={<InvoiceDetailPage />} />
          <Route path="payments"     element={<PaymentsPage />} />
          <Route path="aging"        element={<AgingPage />} />
        </Route>

        <Route path="/accounting" element={
          <ProtectedRoute module="accounting">
            <AccountingLayout />
          </ProtectedRoute>
        }>
          <Route index                element={<Navigate to="/accounting/chart" replace />} />
          <Route path="chart"         element={<ChartOfAccountsPage />} />
          <Route path="journal"       element={<JournalPage />} />
          <Route path="trial-balance" element={<TrialBalancePage />} />
          <Route path="pnl"           element={<ProfitLossPage />} />
          <Route path="balance-sheet" element={<BalanceSheetPage />} />
        </Route>

        <Route path="/newsletter" element={
          <ProtectedRoute module="newsletter">
            <NewsletterLayout />
          </ProtectedRoute>
        }>
          <Route index                       element={<Navigate to="/newsletter/campaigns" replace />} />
          <Route path="campaigns"            element={<CampaignsPage />} />
          <Route path="subscribers"          element={<SubscribersPage />} />
          <Route path="audiences"            element={<AudiencesPage />} />
          <Route path="templates"            element={<TemplatesPage />} />
          <Route path="suppressions"         element={<SuppressionsPage />} />
        </Route>
        {/* Campaign editor + detail sit outside the layout to use the full width */}
        <Route path="/newsletter/campaigns/new" element={
          <ProtectedRoute module="newsletter">
            <CampaignEditorPage />
          </ProtectedRoute>
        } />
        <Route path="/newsletter/campaigns/:id/edit" element={
          <ProtectedRoute module="newsletter">
            <CampaignEditorPage />
          </ProtectedRoute>
        } />
        <Route path="/newsletter/campaigns/:id" element={
          <ProtectedRoute module="newsletter">
            <CampaignDetailPage />
          </ProtectedRoute>
        } />

        <Route path="/reports" element={
          <ProtectedRoute module="reports">
            <ModulePlaceholder
              kicker="Reports · Analytics"
              title="Cross-module reporting & exports."
              description="Ad-hoc and scheduled reports spanning sales, production, inventory and financials."
              planned={[
                'Report builder with drag-and-drop fields',
                'Saved views shared by department',
                'Scheduled email delivery via AWS SES',
                'CSV, PDF and Excel exports',
                'Executive summary dashboards',
              ]}
            />
          </ProtectedRoute>
        } />

        <Route path="/hr" element={
          <ProtectedRoute module="hr">
            <ModulePlaceholder
              kicker="People · HR"
              title="Employees, time & onboarding."
              description="65+ team members across production, finish, shipping, sales and administration."
              planned={[
                'Employee directory with org chart',
                'Time & attendance with payroll export',
                'Certifications and training records',
                'Onboarding checklists',
                'Document storage (offer letters, W-4s, reviews)',
              ]}
            />
          </ProtectedRoute>
        } />

        {/* Settings — fully built out */}
        <Route path="/settings" element={
          <ProtectedRoute module="settings">
            <SettingsLayout />
          </ProtectedRoute>
        }>
          <Route index element={<Navigate to="/settings/users" replace />} />
          <Route path="users"        element={<UsersSettings />} />
          <Route path="roles"        element={<RolesSettings />} />
          <Route path="company"      element={<CompanySettings />} />
          <Route path="integrations" element={<IntegrationsSettings />} />
          <Route path="audit"        element={<AuditSettings />} />
          <Route path="preferences"  element={<PreferencesSettings />} />
        </Route>

        <Route path="/403" element={<ForbiddenPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
